import React from "react";
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-light pt-3">
      <Container>
        <Row>
          <Col xs={12} className="text-center">
            <Nav className="justify-content-center">
              <LinkContainer to="/privacy-policy">
                <Nav.Link>{t('privacy_policy')}</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/impressum">
                <Nav.Link>{t('impressum')}</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/terms-conditions">
                <Nav.Link>{t('terms_conditions')}</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/return-refund">
                <Nav.Link>{t('return_refund')}</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/cookies-consent">
                <Nav.Link>{t('cookies')}</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/contact">
                <Nav.Link>{t('contact')}</Nav.Link>
              </LinkContainer>
            </Nav>
          </Col>
        </Row>
        <Row>
          <Col className="my-3 text-center">
            <p>&copy; {new Date().getFullYear()} L & M Brasil Produtos {t('copyright')}</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
